import React from 'react';
import { Shield } from 'lucide-react';
import { supportedRegulations } from '../data/mock';

const Regulations = () => {
  return (
    <section className="bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 relative overflow-hidden" style={{ paddingTop: '80px', paddingBottom: '80px' }}>
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-grid-white" />
      </div>

      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm text-white rounded-full text-sm font-medium mb-5">
            <Shield className="w-4 h-4" />
            Legal Framework
          </div>
          
          <h2 
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-3 leading-tight mx-auto"
            style={{ 
              maxWidth: '22ch',
              textWrap: 'balance',
              WebkitTextWrap: 'balance'
            }}
          >
            Supported Regulations
          </h2>
          <p 
            className="text-lg sm:text-xl text-blue-100 mx-auto leading-relaxed"
            style={{ 
              maxWidth: '50ch',
              textWrap: 'balance',
              WebkitTextWrap: 'balance'
            }}
          >
            We handle claims under official aviation compensation laws
          </p>
        </div>

        {/* Regulations */}
        <div className="grid md:grid-cols-2 gap-6 mb-8">
          {supportedRegulations.map((regulation, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-md rounded-2xl p-6 text-left border border-white/20">
              <h3 
                className="text-xl font-bold text-white mb-3"
                style={{ 
                  textWrap: 'balance',
                  WebkitTextWrap: 'balance'
                }}
              >
                {regulation.title}
              </h3>
              <p 
                className="text-blue-100 mb-2 leading-relaxed text-sm"
                style={{ 
                  textWrap: 'balance',
                  WebkitTextWrap: 'balance'
                }}
              >
                {regulation.description}
              </p>
              <p className="text-sm text-blue-200 font-medium">{regulation.region}</p>
            </div>
          ))}
        </div>

        {/* Compensation Amounts */}
        <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 border border-white/20">
          <h3 
            className="text-2xl sm:text-3xl font-bold text-white mb-8 text-center"
            style={{ 
              textWrap: 'balance',
              WebkitTextWrap: 'balance'
            }}
          >
            Compensation Amounts
          </h3>
          <div className="grid sm:grid-cols-3 gap-6">
            <div className="text-center">
              <p className="text-xs sm:text-sm mb-2 text-blue-100">Short Distance</p>
              <p className="text-4xl sm:text-5xl font-bold text-white mb-2">€250</p>
              <p className="text-xs sm:text-sm text-blue-200 whitespace-nowrap">Up to 1,500 km</p>
            </div>
            <div className="text-center">
              <p className="text-xs sm:text-sm mb-2 text-blue-100">Medium Distance</p>
              <p className="text-4xl sm:text-5xl font-bold text-white mb-2">€400</p>
              <p className="text-xs sm:text-sm text-blue-200 whitespace-nowrap">1,500 - 3,500 km</p>
            </div>
            <div className="text-center">
              <p className="text-xs sm:text-sm mb-2 text-blue-100">Long Distance</p>
              <p className="text-4xl sm:text-5xl font-bold text-white mb-2">€600</p>
              <p className="text-xs sm:text-sm text-blue-200 whitespace-nowrap">Over 3,500 km</p>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-8 text-center">
          <p 
            className="text-sm text-blue-200 italic mx-auto leading-relaxed"
            style={{ 
              maxWidth: '60ch',
              textWrap: 'balance',
              WebkitTextWrap: 'balance'
            }}
          >
            * Eligibility depends on specific circumstances including reason for delay, airline responsibility, 
            and other factors. Our AI system evaluates each case individually.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Regulations;
